import React from "react";
import PropTypes from "prop-types";
import { CHECK_IN_LANG } from "../hooks/useCheckInLanguage";

function LanguageToggle({ lang, onEnglish, onSpanish, className }) {
  const wrapperClass = ["lb-lang-toggle", "d-flex", "justify-content-center", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClass} data-cy="check-in-lang-toggle">
      <button
        type="button"
        className="lb-btn a mx-1"
        onClick={onEnglish}
        data-cy="check-in-lang-en"
        aria-pressed={lang === CHECK_IN_LANG.EN}
      >
        ENGLISH
      </button>
      <button
        type="button"
        className="lb-btn a mx-1"
        onClick={onSpanish}
        data-cy="check-in-lang-es"
        aria-pressed={lang === CHECK_IN_LANG.ES}
      >
        ESPAÑOL
      </button>
    </div>
  );
}

LanguageToggle.propTypes = {
  lang: PropTypes.oneOf([CHECK_IN_LANG.EN, CHECK_IN_LANG.ES]).isRequired,
  onEnglish: PropTypes.func.isRequired,
  onSpanish: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default LanguageToggle;
